import { render, staticRenderFns } from "./SurveyApp.vue?vue&type=template&id=ec5e22d0"
import script from "./SurveyApp.vue?vue&type=script&lang=js"
export * from "./SurveyApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports